import request from '../http/index'

// 列表查询
export async function HospitalDoctorInfoList(data = {}) {
	const res = await request.post('/api/ba/HospitalDoctorInfo/List', data)
	return res.data
}

// 导出
export async function HospitalDoctorInfoExport(data = {}) {
	const res = await request.post('/api/ba/HospitalDoctorInfo/Export', data, {
		responseType: 'blob'
	})
	return res.data
}